// import { useState } from 'react';
// import { Camera, Info } from 'lucide-react';
// import { Form } from 'react-bootstrap';
// import CreatePostModal from './CreatePostModal';

// export default function TimelineSection() {
//   const [showPostModal, setShowPostModal] = useState(false);

//   return (
//     <>
//     {/* <TimelineSection id='timeline'/> */}
//       <div id='timeline' className="card shadow-sm">
//         <div className="card-body p-4">
//           {/* Post Creation Area */}
//           <div className="d-flex gap-3 mb-4">
//             <div
//               className="rounded-circle bg-light"
//               style={{ width: '40px', height: '40px' }}
//             >
//               <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted">
//                 👤
//               </div>
//             </div>
//             <div className="flex-grow-1">
//               <Form>
//                 <Form.Control
//                   as="textarea"
//                   placeholder="Share what's on your mind, Dustin..."
//                   className="border-0 bg-light resize-none"
//                   style={{ minHeight: '60px' }}
//                 />
//               </Form>
//               <div className="mt-2">
//                 <button
//                   className="btn btn-link text-muted p-0"
//                   onClick={() => setShowPostModal(true)}
//                 >
//                   <Camera size={20} />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* No Activity Message */}
//           <div className="d-flex align-items-center gap-2 text-muted mt-4">
//             <div
//               className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
//               style={{ width: '32px', height: '32px' }}
//             >
//               <Info size={16} className="text-white" />
//             </div>
//             <span>Sorry, there was no activity found.</span>
//           </div>
//         </div>
//       </div>

//       <CreatePostModal
//         show={showPostModal}
//         onHide={() => setShowPostModal(false)}
//         userName="Dustin"
//       />
//     </>
//   );
// }

import { useState } from 'react';
import { Camera, Info, Send } from 'lucide-react';
import { Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import CreatePostModal from './CreatePostModal';
 
export default function TimelineSection() {
  const [showPostModal, setShowPostModal] = useState(false);
  const [postText, setPostText] = useState('');
 
  const handlePostSubmit = () => {
    Swal.fire({
      title: 'Post Submitted!',
      text: 'Your post has been successfully shared.',
      icon: 'success',
      confirmButtonText: 'OK',
    });
    setPostText('');
  };
 
  return (
    <>
      <div id="timeline" className="card shadow border-0 rounded-4">
        <div className="card-body p-4">
          {/* Post Creation Area */}
          <div className="d-flex gap-3 mb-4 align-items-center">
            {/* Profile Icon */}
            <div
              className="rounded-circle bg-light d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: '50px',
                height: '50px',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                background: 'linear-gradient(to right, #ff7eb3, #ff758c)',
                color: 'white',
              }}
            >
              D
            </div>
 
            {/* Post Input */}
            <div className="flex-grow-1">
              <Form>
                <Form.Control
                  as="textarea"
                  value={postText}
                  onChange={(e) => setPostText(e.target.value)}
                  placeholder="What's on your mind?✨"
                  className="border-0 bg-light rounded-3 shadow-lg p-3"
                  style={{
                    minHeight: '75px',
                    resize: 'none',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', // Increased shadow intensity
                  }}
                />
              </Form>
  
              {/* Action Buttons */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-light border d-flex align-items-center gap-2 shadow-sm"
                  onClick={() => setShowPostModal(true)}
                  style={{
                    borderRadius: '25px',
                    padding: '10px 15px',
                    transition: '0.3s ease-in-out',
                  }}
                >
                  <Camera size={20} />
                  <span>Add Photo</span>
                </button>
                <button
                  className="btn btn-primary d-flex align-items-center gap-2 shadow-sm"
                  disabled={!postText.trim()}
                  onClick={handlePostSubmit}
                  style={{
                    borderRadius: '25px',
                    padding: '10px 15px',
                    transition: '0.3s ease-in-out',
                    opacity: postText.trim() ? 1 : 0.6,
                  }}
                >
                  <Send size={18} />
                  <span>Post</span>
                </button>
              </div>
            </div>
          </div>
 
          {/* No Activity Message */}
          <div className="text-center mt-5">
            <div className="rounded-circle p-3 d-inline-flex align-items-center justify-content-center shadow-sm"
              style={{
                background: 'rgba(0, 123, 255, 0.1)',
                width: '55px',
                height: '55px',
              }}
            >
              <Info size={24} className="text-primary" />
            </div>
            <p className="text-muted mt-3 fw-semibold">No posts yet. Start the conversation!</p>
          </div>
        </div>
      </div>
 
      {/* Create Post Modal */}
      <CreatePostModal
        show={showPostModal}
        onHide={() => setShowPostModal(false)}
        userName="Dustin"
      />
    </>
  );
}